import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ConfirmEmail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setStatus] = useState("loading");

    // Helper: extract "confirmation" code from query params
    const getCodeFromURL = () => {
        const params = new URLSearchParams(location.search);
        return params.get("confirmation");
    };

    useEffect(() => {
        const code = getCodeFromURL();
        if (!code) {
            // Strapi confirms the token itself and only then redirects here
            // (email_confirmation_redirection) without any query params
            setStatus("success");
            const timer = setTimeout(() => navigate("/login"), 2000);
            return () => clearTimeout(timer);
        }
        fetch(`${process.env.REACT_APP_API_URL}/auth/email-confirmation?confirmation=${code}`)
            .then(res => res.json())
            .then(data => {
                if (data.user) {
                    setStatus("success");
                    // Optionally redirect after a delay
                    setTimeout(() => {
                        navigate("/login");
                    }, 2000);
                } else {
                    setStatus("error");
                }
            })
            .catch(() => setStatus("error"));
    }, [location, navigate]);

    if (status === "loading") return <div>Confirming your email...</div>;
    if (status === "success") return <div>Your email has been confirmed! Redirecting to login...</div>;
    return <div>Email confirmation failed or invalid link.</div>;
};

export default ConfirmEmail;
